/**
 * @generated SignedSource<<c9db60b4539190d88e88c57fa77f0326>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ChatChannelKind = "chat_bot" | "custom" | "default" | "direct_message" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type CreateMemberChatChannelsCSVDataInput = {
  externalChannelIds?: ReadonlyArray<string> | null;
  hideDraftProducts?: boolean | null;
  includeProductLevel?: boolean | null;
  kind?: ChatChannelKind | null;
  kinds?: ReadonlyArray<ChatChannelKind> | null;
  noNavSection?: boolean | null;
  orderBy?: OrderByInput | null;
  organizationMembershipId: string;
  productIds?: ReadonlyArray<string> | null;
  search?: string | null;
};
export type OrderByInput = {
  direction: OrderDirection;
  field: string;
};
export type AdminMembersReportChannelsTableExportCSVButtonMutation$variables = {
  input: CreateMemberChatChannelsCSVDataInput;
};
export type AdminMembersReportChannelsTableExportCSVButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type AdminMembersReportChannelsTableExportCSVButtonMutation = {
  response: AdminMembersReportChannelsTableExportCSVButtonMutation$data;
  variables: AdminMembersReportChannelsTableExportCSVButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMemberChatChannelsCSVDataResponse",
    "kind": "LinkedField",
    "name": "createMemberChatChannelsCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportChannelsTableExportCSVButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportChannelsTableExportCSVButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "90fc60bbc750c41e6e462ecaab43b8cf",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportChannelsTableExportCSVButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminMembersReportChannelsTableExportCSVButtonMutation(\n  $input: CreateMemberChatChannelsCSVDataInput!\n) {\n  response: createMemberChatChannelsCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1e25ad7eafa81478f573c672bfc13040";

export default node;
